// src/utils/deliveryAxios.js
import axios from "axios";
import config from "../config";

const deliveryAxios = axios.create({
  baseURL: `${config.url}/api/delivery/v2`,
});

// Request interceptor to inject deliveryAuthToken
deliveryAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('deliveryAuthToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
deliveryAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to delivery login
      localStorage.removeItem('deliveryAuthToken');
      localStorage.removeItem('deliveryPartnerData');
      window.location.href = '/delivery/login';
    }
    return Promise.reject(error);
  }
);

export default deliveryAxios;
